import React from 'react';
import './Info.css';

class Info extends React.Component {
    render() {
        return (
            <div className="authors">
                Спроєктовано <a href={this.props.devlink}>{this.props.dev}</a> <br/>
                Розроблено <a href={this.props.devlink}>{this.props.dev}</a> <br/>
                API rate - <a href={this.props.apiRateLink}>{this.props.apiRate}</a> <br/>
                API news - <a href={this.props.apiNewsLink}>{this.props.apiNews}</a> <br/>
            </div>
        )
    }
}

export default Info;